<template lang="pug">
#historico
    .row
        .col-12
            .row.justify-content-center.align-items-center
                .safra
                    el-radio-group(
                        v-model='safraSelecionada',
                        @change='onChangeTipoSafra'
                    )
                        el-radio-button(label='SAFRA') Safra
                        el-radio-button(label='SAFRINHA') Safrinha
            .row
                .col-12
                    .mapa-historico.row
                        .col-4
                            .timeline(v-loading='loadingHistorico')
                                span(v-if='!dadosHistoricoFiltrados.length')
                                    empty-result.empty-result(
                                        :min-height='150',
                                        icon-class='mdi-alert-octagon',
                                        message='Não há dados históricos processados para essa área'
                                    )
                                span(v-if='dadosHistoricoFiltrados.length > 0')
                                    timeline(
                                        :historico='dadosHistoricoFiltrados',
                                        @on-change='atualizarGeometriaAreaPlantada'
                                    )

                        .col-8
                            .mapa
                                mapa(
                                    v-if='layersMaps',
                                    :mapLayersConfigs='layersMaps',
                                    :mapConfig='mapConfig',
                                    :locked='true',
                                    height='340px',
                                    idMapa='mapaHistoricoAreaMonitorada',
                                    ref='mapa'
                                )

                                legenda(:values='legenda')

        .col-12.row-grafico(v-loading='loadingHistorico')
            card(title='Área colhida', v-if='dadosHistoricoFiltrados')
                grafico-area-colhida(
                    ref='graficoAreaColhida',
                    :dadosHistorico='dadosHistoricoFiltrados'
                )

        .col-12.row-grafico(v-loading='loadingHistorico')
            card(title='Produtividade', v-if='dadosHistoricoFiltrados')
                grafico-produtividade-media(
                    ref='graficoProdutividadeMedia',
                    :dadosHistorico='dadosHistoricoFiltrados'
                )

        .col-12.row-grafico(v-loading='!dadosClimaticos')
            card(title='Chuva acumulada')
                grafico-pluviosidade(
                    v-if='dadosClimaticos',
                    :historico='dadosClimaticos.precipitacao'
                )

        .col-12.row-grafico(v-loading='!dadosClimaticos')
            card(title='Temperatura média')
                grafico-temperatura(
                    v-if='dadosClimaticos',
                    :historico='dadosClimaticos'
                )
</template>

<script>
import L from 'leaflet';
import Card from '../Card';

import GraficoAreaColhida from './graficos/GraficoAreaColhida';
import GraficoProdutividadeMedia from './graficos/GraficoProdutividadeMedia';
import GraficoPluviosidade from './graficos/GraficoPluviosidade';
import GraficoTemperatura from './graficos/GraficoTemperatura';

import Timeline from './historico/Timeline';
import Mapa from '../MapaLeaflet';
import LayerStyle, { getEstiloCultura } from '../../utils/layerStyles';
import EmptyResult from '../EmptyResult';

import AreasMonitoradasService from '../../services/AreasMonitoradasService';
import Legenda from '../Legenda';
import { LEGENDA_MAPA_HISTORICO } from '../../utils/layouts/legendas';
import { CULTURAS } from '../../utils/TipoCultura';

import { sortBy } from 'lodash';

export default {
    name: 'Historico',

    props: {
        dadosAreaMonitorada: {
            type: Object,
            required: true
        }
    },

    components: {
        Timeline,
        Legenda,
        GraficoTemperatura,
        GraficoPluviosidade,
        GraficoProdutividadeMedia,
        GraficoAreaColhida,
        Card,
        Mapa,
        EmptyResult
    },

    data() {
        return {
            dadosHistorico: [],
            dadosHistoricoFiltrados: [],
            layersMaps: null,
            layerCulturas: null,
            loadingHistorico: true,
            mapConfig: {
                controls: {
                    zoomControl: true
                }
            },
            safraSelecionada: 'SAFRA',
            legenda: LEGENDA_MAPA_HISTORICO,
            dadosClimaticos: null
            // coresTemperaturaMinima: ['#20E59A', '#1CB279', '#249268', '#267356', '#21634A', '#1A4334']
            // coresTemperaturaMinima: ['#95E1E1', '#91CCCC', '#81A7A7', '#5D7F7F', '#4D6666', '#344B4B']
        };
    },

    methods: {
        atualizarGeometriaAreaPlantada(idSafra) {
            if (!this.layerCulturas) {
                this.layerCulturas = L.layerGroup();
                this.$refs.mapa.mapa.addLayer(this.layerCulturas);
            } else {
                this.layerCulturas.clearLayers();
            }
            AreasMonitoradasService.geometriaHistoricoAgro(
                this.dadosAreaMonitorada.id,
                idSafra
            ).then(({ data }) => {
                data.forEach(culturaPorSafra => {
                    const estilo =
                        getEstiloCultura(
                            CULTURAS[culturaPorSafra.cultura.codigo]
                        ) || LayerStyle.AREA_PLANTADA();

                    culturaPorSafra.geometrias.forEach(geometria => {
                        const layerCultura = L.geoJSON(geometria, estilo);
                        layerCultura.bindTooltip(culturaPorSafra.cultura.nome);

                        this.layerCulturas.addLayer(layerCultura);
                    });
                });
            });
        },

        /*
			O serviço de histórico retorna os dados de todos os anos e safras, armazenados em this.dadosHistorico.
			Os dados referente à safra selecionada são mantidos na variável this.dadosHistoricoFiltrados.
			A cada vez que a safra ou a cultura são alteradas é preciso atualizar os dados filtrados. */
        atualizarDadosFiltrados() {
            this.dadosHistoricoFiltrados = [
                ...this.dadosHistorico.filter(
                    d => d.safra.tipoSafra === this.safraSelecionada
                )
            ];
            this.dadosHistoricoFiltrados = sortBy(
                this.dadosHistoricoFiltrados,
                ['safra.ano']
            );
        },

        onChangeTipoSafra() {
            this.atualizarDadosFiltrados();
        },

        configureLayersMapa() {
            this.layersMaps = [];

            let layerAreaMonitorada = {
                style: LayerStyle.AREA_MONITORADA(),
                name: 'Área Monitorada',
                geoJson: this.dadosAreaMonitorada.geometria
            };

            this.layersMaps.push(layerAreaMonitorada);
        },

        fetchHistoricoAgro() {
            this.loadingHistorico = true;
            AreasMonitoradasService.historicoAgro(this.dadosAreaMonitorada.id)
                .then(({ data }) => {
                    this.dadosHistorico = data;
                })
                .finally(() => {
                    this.configureLayersMapa();
                    this.loadingHistorico = false;
                    this.atualizarDadosFiltrados();
                    // if (this.dadosHistoricoFiltrados.length) {
                    // 	this.atualizarGeometriaAreaPlantada(this.dadosHistoricoFiltrados[0].id,
                    // 		this.dadosHistoricoFiltrados[0].safra.id);
                    // }
                });
        },

        fetchDadosHistoricosClima() {
            AreasMonitoradasService.historicoClimatico(
                this.dadosAreaMonitorada.id
            ).then(({ data }) => {
                this.dadosClimaticos = data;
            });
        }
    },

    created() {
        this.fetchHistoricoAgro();

        this.fetchDadosHistoricosClima();
    }
};
</script>

<style lang="scss" scoped>
#historico {
    .row-grafico {
        margin-top: 20px;
    }

    .mapa-historico {
        .col-4 {
            padding-right: 0;
        }

        .col-8 {
            padding-left: 0;
        }
    }

    .safra {
        margin-bottom: 20px;
    }

    .timeline {
        display: flex;
        position: relative;
        background-color: var(--white);
        height: 100%;
        @include border-radii(4px, 0, 0, 4px);

        .row {
            margin: 0 !important;
            width: 100%;
        }

        span {
            width: 100%;
        }

        .empty-result {
            margin-top: 6rem;
        }
    }

    .mapa {
        position: relative;
    }

    #mapaHistoricoAreaMonitorada {
        @include border-radii(0, 4px, 4px, 0);
    }
}
</style>
